import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/settings.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-aee71242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "HR Service Management")
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "flex justify-around flex-wrap"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "card flex mt-4 cursor-pointer w-80 h-48" }
const _hoisted_6 = { class: "p-2 gap-4 m-4 flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "w-8 h-8"
  })
], -1))
const _hoisted_8 = { class: "flex flex-col w-4/5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm overflow" }, " fact that readable fact that readable fact that readable fact fact that readable fact that readable fact that readable fact that readable fact that readable fact that readable that readable fact that readable fact that readable content of a page when looking at its layout ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute top-full left-1/2 z-20 mt-3 size rounded bg-black py-[6px] px-4 text-white opacity-0 group-hover:opacity-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "absolute top-3 left-1/2 -z-10 h-2 w-2 rotate-45 rounded-sm bg-black" }),
  /*#__PURE__*/_createTextVNode(" fact that readable fact that readable fact that readable fact fact that readable fact that readable fact that readable fact that readable fact that readable fact that readable that readable fact that readable fact that readable content of a page when looking at its layout ")
], -1))
const _hoisted_11 = {
  key: 1,
  class: "flex justify-center items-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No Data", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "Popup w-full overflow-y-auto fixed inset-0 z-index"
}
const _hoisted_15 = { class: "fixed inset-0 z-index justify-center items-center flex" }
const _hoisted_16 = { class: "relative w-4/6 my-6 mx-auto max-w-xl" }
const _hoisted_17 = { class: "popup border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none" }
const _hoisted_18 = {
  key: 0,
  class: "card justify-center items-center flex mt-4"
}
const _hoisted_19 = { class: "w-full bg-red overflow-y-scroll max-h-96" }
const _hoisted_20 = { class: "flex flex-col w-full bg-white" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex p-5 border-b border-solid border-lightgrey rounded-t" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "formcontainer flex mr-2" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Create Task")
  ])
], -1))
const _hoisted_22 = { class: "p-6" }
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Task Name", -1))
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Summary", -1))
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Description", -1))
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "controllabel font-normal text-sm mb-1" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  type: "radio"
}
const _hoisted_34 = {
  key: 1,
  type: "checkbox"
}
const _hoisted_35 = { class: "ml-2 mb-2" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "inputboxstyling" }
const _hoisted_38 = { class: "flex justify-center mt-2" }
const _hoisted_39 = {
  key: 0,
  class: "opacity-25 fixed inset-0 z-50 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.allProcesses.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Processes, (processes) => {
            return (_openBlock(), _createElementBlock("div", {
              key: processes._id,
              onClick: ($event: any) => (_ctx.showConfiguration(processes._id)),
              class: "mt-2"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h1", null, _toDisplayString(processes.name), 1),
                    _hoisted_9,
                    _hoisted_10
                  ])
                ])
              ])
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)),
    (_ctx.showPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_ctx.showPreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "inputboxstyling",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tasks.taskName) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.tasks.taskName]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "inputboxstyling",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tasks.summary) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.tasks.summary]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _withDirectives(_createElementVNode("textarea", {
                                type: "text",
                                class: "inputboxstyling",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tasks.description) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.tasks.description]
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.singleconfig.controls, (control, controlIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "text-black no-underline min-h-30 cursor-pointer",
                                key: controlIndex
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("label", _hoisted_30, _toDisplayString(control.label), 1),
                                    (control.controlType == 'TextBox' || control.controlType == 'TextArea')
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: "text",
                                          class: "inputboxstyling",
                                          "onUpdate:modelValue": ($event: any) => ((control.value) = $event)
                                        }, null, 8, _hoisted_31)), [
                                          [_vModelText, control.value]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  (control.controlType == 'Radio' || control.controlType == 'CheckBox')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.controls[controlIndex].options, (option) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "min-h-30",
                                            key: option
                                          }, [
                                            (control.controlType == 'Radio')
                                              ? (_openBlock(), _createElementBlock("input", _hoisted_33))
                                              : _createCommentVNode("", true),
                                            (control.controlType == 'CheckBox')
                                              ? (_openBlock(), _createElementBlock("input", _hoisted_34))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("label", _hoisted_35, _toDisplayString(option.option), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (control.controlType == 'Dropdown')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createElementVNode("select", _hoisted_37, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.controls[controlIndex].options, (option) => {
                                            return (_openBlock(), _createElementBlock("option", { key: option }, _toDisplayString(option.option), 1))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", {
                                class: "btnprimary mr-2",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
                              }, "Cancel"),
                              _createElementVNode("button", {
                                class: "btnprimary",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save(_ctx.singleconfig.controls)))
                              }, "Save")
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.showPreview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}